import styled from "styled-components"

export const Wrapper = styled.div`
width: 60%;
height: 500px;
display: flex;
justify-content: flex-start ;
align-items:flex-start;
flex-direction: column;
position: relative;
`
export const Title = styled.div`
color:#002E5C;
margin-top: 10px;
font-size: 20px;
font-weight: bolder;
line-height: 32px;
`
export const CampaignSectionWrapper = styled.div`
width: 100%;
display: flex;
justify-content: flex-start !important;
align-items:center;
margin-top: 20px;
`
export const CheckBoxWrapper = styled.div`
display: flex;
justify-content: center;
align-items:center;
width: 50%;
padding-top: 6%;
`
export const FooterWrapepr = styled.div`
position: absolute;
bottom: 0;
right: 0;
`